import { Theme } from "app/core/theme/theme.interface";
import { THEMES } from "app/core/theme/theme-data";
import { HASH } from "app/core/theme/theme.hash";
import { ThemeService } from "app/core/theme/theme.service";

/**
 * Set the theme css file before bootstrapping the app
 */
export function ThemeInitFactory(): Promise<void> {
  const currentTheme: string | null = localStorage.getItem("CURRENT_THEME");
  const themes: Theme[] = THEMES;

  return new Promise((resolve: any) => {
    const link: HTMLLinkElement = document.createElement("link");
    link.rel = "stylesheet";
    link.id = "theme-stylesheet";
    link.type = "text/css";
    document.head.appendChild(link);

    // Wait for the css file to finish loading, then resolve the promise which results in bootstrapping the app (main.ts)
    link.addEventListener("load", () => {
      resolve();
    });

    // Set theme for production and tdev servers (matched by location.host)
    themes.forEach((theme: Theme) => {
      if (window.location.host.match(theme.host)) {
        setTheme(theme.value);
      }
    });

    // Set theme for local environment if theme has already been selected once
    if ((ThemeService.isDevHost || (window as any).e2e) && currentTheme) {
      setTheme(currentTheme.trim().replace(/"/g, ""));
    }

    // When you're on localhost, the app starts for the first time and no currentTheme exists, nconnect-voice  will be the default
    if (!link.href) {
      setTheme("nconnect-voice-theme");
    }

    /**
     *
     * Define active theme by setting the href and the body class
     */
    function setTheme(theme: string): void {
      link.href = `${theme}.${HASH}.css`;
      document.body.className = theme;
    }
  });
}
